import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=42d21b87"
import script from "./gateway.vue?vue&type=script&lang=ts"
export * from "./gateway.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports